<template>
  <div class="page-container">
    <Filter :params="params.filter(item=> item.isShow !== false)" @search="searchData">
      <template #handle>
      </template>
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage" select @select="handleSelect">
      <template #toolBar>
        <span style="margin-right: 20px;">{{$t('status.robot.currentOtaLatestVersionColon')}}{{ otaNewVer }}
        </span>
        <el-button v-show="authList.includes('robotStatus:upgrade')" :disabled="!batchDataList.length" size="small" type="primary" @click="upgradeOTA">{{$t('status.robot.upgradeSelectedDevices')}}</el-button>
        <!-- <el-button size="small" type="primary" @click="upgradeOTA">升级全部设备</el-button> -->
      </template>
      <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" width="100" />
      <el-table-column prop="robotName" :label="$t('status.largescreenm.robotName')" width="100" />
      <el-table-column v-if="userInfo?.internalUser && !standard" prop="company" :label="$t('activity.signin.customerName')" width="100">
        <template #default="scope">
          {{ scope.row.company }}
        </template>
      </el-table-column>
      <el-table-column prop="modelName" :label="$t('equipment.cabinet.specModel')" width="100" />
      <!-- <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')" width="100" /> -->
      <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')" width="100">
        <template #default="scope">
          <span v-if="scope.row.cabinetId?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetId)">{{scope.row.cabinetId}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetId}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="version" label="软件版本" />
      <el-table-column prop="companyName" label="公司名称" /> -->
      <!-- <el-table-column label="机器人位置">
        <template #default="{row}">
          {{ row.ip }} 
          {{ row.ip && (row.province || row.city) ? ' - ' : '' }} 
          {{ row.province }} {{ row.city }} 
        </template>
      </el-table-column> -->
      <el-table-column prop="location" :label="$t('equipment.cabinet.robotLocation')" width="120" />
      <el-table-column prop="qccid" :label="$t('status.robot.iotCardNumber')" width="100" />
      <el-table-column
        prop="status"
        :label="$t('collect.tasklist.robotStatus')"
        :formatter="formatStatus"
      />
      <el-table-column :label="$t('status.robot.collisionStatus')">
        <template #default="scope">
          {{ scope.row.protectiveStop ? $t("activity.detail.yes") : $t("activity.detail.no") }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('status.robot.emergencyStopStatus')">
        <template #default="scope">
          {{ scope.row.emergencyStop ? $t("activity.detail.yes") : $t("activity.detail.no") }}
        </template>
      </el-table-column>
      <el-table-column prop="firstReceiveTime" :label="$t('status.robot.firstConnectionTime')" width="180" />
      <el-table-column prop="sumRunningTime" :label="$t('status.robot.totalOperatingTime')" width="120" />
      <el-table-column prop="queryTime" :label="$t('error.alarm.queryTime')" width="180" />
      <el-table-column prop="allowOtaUpgrade" :label="$t('status.robot.allowAutoUpgrade')" width="100">
        <template #default="{ row }">{{ row.allowOtaUpgrade ? $t('activity.detail.yes') : $t('activity.detail.no') }}</template>
      </el-table-column>
      <el-table-column prop="otaClientVersion" :label="$t('status.robot.currentOtaVersion')" width="100" />
      <el-table-column prop="programName" :label="$t('status.robot.currentRunningProgram')" width="100">
        <template #default="{ row }">{{ row.status == 5 ? '' : row.programName }}</template>
      </el-table-column>
      <!-- <el-table-column prop="targetOtaClientVersion" label="目标OTA版本" width="100" />
      <el-table-column prop="otaUpgradeStatus" label="升级状态" width="100">
        <template #default="{ row }">{{ otaUpgradeMap[row.otaUpgradeStatus] }}</template>
      </el-table-column>
      <el-table-column prop="errorMessage" label="失败原因" width="180" show-overflow-tooltip />
      <el-table-column prop="otaUpgradeTime" label="升级操作时间" width="180" /> -->
      <el-table-column :label="$t('activity.list.operation')" width="90" fixed="right">
        <template #default="scope">
          <el-button type="text" size="mini" @click="handleClick(scope.row)"
            >{{$t('event.crash.refreshStatus')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
    <el-dialog :title="$t('service.upgrade.confirm')" v-model="dialogOpenFormVisible" destroy-on-close :modal="true" :append-to-body="true">
      <!-- <div class="section-title">{{$t('service.upgrade.deviceListHint')}}</div> -->
      <!-- <template> -->
        <!-- <el-descriptions direction="vertical" :column="3" border>
          <el-descriptions-item :label="$t('activity.packetjoin.robotCode')">{{ upgradeData.robotSN }}</el-descriptions-item>
          <el-descriptions-item :label="$t('collect.healthscorelist.ctrlCabCode')">{{ upgradeData.cabinetSN }}</el-descriptions-item>
          <el-descriptions-item :label="$t('collect.tasklist.robotStatus')">{{ robotStatusMap[upgradeData.status] }}</el-descriptions-item>
        </el-descriptions> -->
        <div class="section-title">{{$t('service.upgrade.content')}}</div>
        <el-table class="dialog-table" max-height="300" :data="tableDataList.filter(item => batchDataList.includes(item.robotId))" border stripe>
          <el-table-column type="index" :label="$t('pages.indexNo')" width="60px" />
          <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" width="100" />
          <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')" width="100">
            <template #default="scope">
              <span v-if="scope.row.cabinetId?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetId)">{{scope.row.cabinetId}}</span>
              <el-popover
                v-else
                placement="top-start"
                :width="400"
                trigger="hover"
                title=""
              >
                <template #default>
                  <el-descriptions title="" column="1" border>
                    <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetId}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                    <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
                  </el-descriptions>
                </template>
                <template #reference>
                  <span style="cursor: pointer;">
                    {{ $t('error.alarm.pendingReport') }}
                    <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
                  </span>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('collect.tasklist.robotStatus')"
            :formatter="formatStatus"
          />
          <el-table-column prop="productName" :label="$t('service.software.productType')" >OTA</el-table-column>
          <el-table-column prop="otaClientVersion" :label="$t('service.upgrade.currentVersionPlatformSlash')"/>
          <el-table-column prop="version" :label="$t('service.upgrade.targetVersionPlatformSlash')">{{ otaNewVer }}</el-table-column>
        </el-table>
      <!-- </template> -->
      <div class="warning-box">
        <div class="warning-icon">
            <i class="el-icon-warning"></i><i class="fas fa-exclamation-triangle"></i>
        </div>
        <div class="warning-text">
            <strong>{{$t('service.upgrade.warning')}}：</strong>{{$t('service.upgrade.warningInfo')}}
        </div>
      </div>
      <el-row :gutter="20" style="width: 500px;margin: 0 auto;">
        <el-col :span="14">
          <el-input :placeholder="$t('views.login.enterVerificationCode')" v-model="detailform.captcha" clearable>
            <!-- <template #prefix>
              <span class="icon iconfont icon-ota-anquan"></span>
            </template> -->
          </el-input>
        </el-col>
        <el-col :span="10" @click="validCode">
          <img class="valid-img" :src="detailform.captchaImg" alt="" srcset="">
        </el-col>
      </el-row>
      <template #footer>
        <el-button size="small" type="primary" @click="formSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "../../common/mixin";
import { ElMessage } from "element-plus";
import { robotStatusMap, statusList } from "@/common/constant";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { otaUpgradeMap } from "@/common/constant"
import { reqUpgradeBatch, reqUpgradeVerList, reqUpgradeNewVer } from "@/api/robot"
import { reactive, ref, toRefs } from "vue";
import { useI18n } from 'vue-i18n'
import { standard } from '@/common/constant';

export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const userInfo = window.localStorage.getItem('userInfo')
    const state = reactive({
      query: {
        allowOtaUpgrade: "",
        robotId: "",
        cabinetId: "",
        firstReceiveTime: [],
        status: [],
        company: "",
        protectiveStop: "",
        emergencyStop: "",
        otaClientVersion: "",
      },
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      options: [
        {
          id: true,
          name: t('activity.detail.yes'),
        },
        {
          id: false,
          name: t('activity.detail.no'),
        },
      ],
      otaNewVer: '',
      batchDataList: [],
      otaUpgradeMap,
      standard: standard,
      userInfo: userInfo ? JSON.parse(userInfo) : {},
      authList: JSON.parse(window.localStorage.getItem('authList')),
      dialogOpenFormVisible: false,
      detailform: {
        captcha: '',
        captchaImg: '',
        captchaKey: '',
      },

    })
    const otaVerList = ref([])
    const params = reactive([
      {
        key: "robotId",
        value: "",
        label: t('activity.packetjoin.robotCode'),
      },
      {
        key: "cabinetId",
        value: "",
        label: t('collect.healthscorelist.ctrlCabCode'),
      },
      {
        key: "company",
        value: "",
        label: t('activity.signin.customerName'),
        isShow: JSON.parse(window.localStorage.getItem('userInfo')).internalUser && !state.standard
      },
      {
        type: "Select",
        key: "status",
        value: "",
        label: t('collect.tasklist.robotStatus'),
        options: {
          data: statusList,
          label: "name",
          value: "id",
        },
        attrs: {
          multiple: true
        }
      },
      {
        type: "Select",
        key: "protectiveStop",
        value: "",
        label: t('status.cabinet.isCollision'),
        options: {
          data: [
            {
              id: true,
              name: t('activity.detail.yes'),
            },
            {
              id: false,
              name: t('activity.detail.no'),
            },
          ],
          label: "name",
          value: "id"
        }
      },
      {
        type: "Select",
        key: "emergencyStop",
        value: "",
        label: t('status.cabinet.isEmergencyStop'),
        options: {
          data: [
            {
              id: true,
              name: t('activity.detail.yes'),
            },
            {
              id: false,
              name: t('activity.detail.no'),
            },
          ],
          label: "name",
          value: "id"
        }
      },
      // {
      //   type: "Select",
      //   key: "otaUpgradeStatus",
      //   value: "",
      //   label: "OTA升级状态",
      //   options: {
      //     data: otaUpgradeList,
      //   }
      // },
      {
        type: "Select",
        key: "allowOtaUpgrade",
        value: "",
        label: t('status.robot.allowAutoUpgrade'),
        options: {
          data: [
            { label: t('activity.detail.yes'), value: true },
            { label: t('activity.detail.no'), value: false },
          ],
        }
      },
      {
        type: "Select",
        key: "otaClientVersion",
        value: "",
        label: t('status.robot.currentOtaVersion'),
        options: {
          data: otaVerList,
        }
      },
      // {
      //   type: "Date",
      //   key: "otaUpgradeTimeRange",
      //   value: [],
      //   label: "升级操作时间",
      //   options: {
      //     "type": "datetimerange",
      //     "format": "YYYY-MM-DD HH:mm:ss",
      //     "value-format": "YYYY-MM-DD HH:mm:ss",
      //     "range-separator": "至",
      //     "start-placeholder": "开始日期",
      //     "end-placeholder": "结束日期",
      //     "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
      //   }
      // },
      {
        type: "Date",
        key: "firstReceiveTime",
        value: [],
        label: t('status.robot.firstConnectionDate'),
        options: {
          "type": "datetimerange",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "range-separator": t('activity.detail.to'),
          "start-placeholder": t('activity.list.startDate'),
          "end-placeholder": t('activity.list.endDate'),
          "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
        }
      },
    ])

    const getData = () => {
      request("getRobotStatus", {
        ...state.query,
        page: state.page,
        size: state.size,
      })
        .then((data) => {
          state.tableDataList = data.records;
          state.total = data.total;
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const getOTAVerList = async () => {
      try {
        const res = await reqUpgradeVerList()
        otaVerList.value = res || []
      } catch (error) {
        console.error(error)
      }
    }
    const getOTAVer = async () => {
      try {
        const res = await reqUpgradeNewVer()
        state.otaNewVer = res
      } catch (error) {
        console.error(error)
      }
    }
    const handleClick = () => {
      getData();
    }
    const searchData = (data) => {
      state.query = data;
      getData();
    }
    const updatePage = (page, size) => {
      state.page = page || 1;
      state.size = size || 10;
      getData();
    }
    const formatStatus = (row) => {
      return robotStatusMap[row.status];
    }
    const handleSelect = (data) => {
      state.batchDataList = data.map((item)=>{
        return item.robotId
      })
    }
    const upgradeOTA = async () => {
      state.dialogOpenFormVisible = true
    }
    const formSubmit = async () => {
      try {
        await reqUpgradeBatch({
          robotIdList: state.batchDataList,
          captcha: state.detailform.captcha,
          captchaKey: state.detailform.captchaKey
        })
        getData();
        state.dialogOpenFormVisible = false
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const validCode = () =>{
      request('validCode', {})
      .then((data) => {
        state.detailform.captchaImg = data.captcha;
        state.detailform.captchaKey = data.key;
      })
      .catch((error) => {
        console.log(error);
      });
    }
    validCode()

    getData()
    getOTAVer()
    getOTAVerList()

    return {
      ...toRefs(state),
      params,
      handleClick,
      searchData,
      updatePage,
      formatStatus,
      handleSelect,
      upgradeOTA,
      validCode,
      formSubmit
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.section-title {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
}

.warning-box {
  background-color: #fff8e1;
  border-radius: 12px;
  padding: 20px;
  margin-top: 32px;
  margin-bottom: 32px;
  border-left: 5px solid #ffb74d;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.warning-icon {
  color: #ff9800;
  font-size: 24px;
  flex-shrink: 0;
}

.warning-text {
  color: #5d4037;
  line-height: 1.6;
  font-size: 15px;
}
</style>